// extracted by mini-css-extract-plugin
module.exports = {"controls":"CarouselControls_controls__IPGgE","controlButton":"CarouselControls_controlButton__Dq_D1","accessibleText":"CarouselControls_accessibleText__WVgLZ"};